import { Route } from '@angular/router';
import { Permissions } from 'src/app/core/common';
import { RoutesConstants } from 'src/app/shared/common';
import { PermissionGuard } from 'src/app/shared/guard/permission-guard';

export const MANAGE_USERS_ACCOUNTS_ROUTES: Route[] = [
  {
    path: RoutesConstants.UPDATE_TEACHERS_INFO_REQUESTS_PAGE_URL,
    loadComponent: () =>
      import('./teacher-update-info-request/pages/teacher-update-info-page/teacher-update-info-page.component').then(
        (x) => x.TeacherUpdateInfoPageComponent
      ),
    data: {
      /* breadcrumb: {
        label: 'TEACHERS_UPDATE_INFO',
        icon: 'edit',
      }, */
      permissions: [Permissions.User_Management_Update_Teacher_Request_Info],
    },
  },
  {
    path: RoutesConstants.USERS_PERMISSIONS_PAGE_URL,
    loadComponent: () =>
      import('./users-permissions/pages/users-permissions-page/users-permissions-page.component').then(
        (x) => x.UsersPermissionsPageComponent
      ),
    data: {
      permissions: [Permissions.User_Management_Admin_Users],
    },
  },
  {
    path: RoutesConstants.USERS_PERMISSIONS_ADD_USER_PAGE_URL,
    loadComponent: () =>
      import('./users-permissions/pages/add-user-page/add-user-page.component').then((x) => x.AddUserPageComponent),
    data: {
      permissions: [Permissions.User_Management_Admin_Users],
    },
  },
  {
    path: RoutesConstants.USERS_PERMISSIONS_ADD_USER_PAGE_URL + '/:id',
    loadComponent: () =>
      import('./users-permissions/pages/update-user-page/update-user-page.component').then(
        (x) => x.UpdateUserPageComponent
      ),
    data: {
      permissions: [Permissions.User_Management_Admin_Users],
    },
  },
  // {
  //   path: RoutesConstants.USERS_REPORTS_PAGE_URL,
  //   loadComponent: () =>
  //     import('./users-reports/pages/users-reports-page/users-reports-page.component').then(
  //       (x) => x.UsersReportsPageComponent
  //     ),
  //   data: {
  //    /*  breadcrumb: {
  //       label: 'USERS_REPORTS',
  //       icon: 'report',
  //     }, */
  //     permissions: [Permissions.User_Management_Report_Student, Permissions.User_Management_Report_Teacher]
  //   },
  // },
  {
    path: RoutesConstants.STUDENT_ACCOUNT_MANAGEMENT_PAGE_URL,
    loadComponent: () =>
      import('./student-settings/pages/students-management-pages/students-management-pages.component').then(
        (x) => x.StudentsSettings
      ),
    data: {
      /* breadcrumb: {
        label: 'STUDENTS_MANAGEMENT',
        icon: 'supervisor_account'
      }, */
      permissions: [
        Permissions.User_Management_View_Student_Dependents,
        Permissions.User_Management_Disable_Student_Reservation,
        Permissions.User_Management_Disable_Student_Account,
        Permissions.User_Management_Disable_Student_Buy,
        Permissions.User_Management_Disable_Student_Call,
        Permissions.User_Management_Student_Disable_Recording,
        Permissions.User_Management_Student_Category,
        Permissions.User_Management_Edit_Beneficiary_Balance,
        Permissions.USER_MANAGEMENT_SET_TEMP_PASSWORD,
        Permissions.USER_MANAGEMENT_VIEW_DEVICE_INFO,
      ],
    },
  },
  {
    path: RoutesConstants.STUDENT_ACCOUNT_DEPENDENTS_MANAGEMENT_PAGE_URL + '/:id',
    loadComponent: () =>
      import('./student-settings/pages/dependents-management/dependents-management.component').then(
        (x) => x.DependentsManagementComponent
      ),
    data: {
      /* breadcrumb: {
        label: 'DEPENDENTS_MANAGEMENT',
        icon: 'supervisor_account'
      }, */
      permissions: [Permissions.User_Management_View_Student_Dependents],
    },
  },
  {
    path: RoutesConstants.STUDENT_PACKAGES_PAGE_URL,
    loadComponent: () =>
      import('./students-packages/pages/students-packages-page/students-packages-page.component').then(
        (x) => x.StudentsPackagesPageComponent
      ),
    data: {
      /* breadcrumb: {
        label: 'STUDENT_PACKAGES',
        icon: 'local_mall'
      }, */
      permissions: [Permissions.User_Management_Student_Packages],
    },
  },
  // {
  //   path: RoutesConstants.STUDENT_JOIN_US_REQUEST_PAGE_URL,
  //   loadComponent: () =>
  //     import(
  //       './student-join-us-request/pages/student-join-us-request-page/student-join-us-request-page.component'
  //     ).then((x) => x.StudentJoinUsRequestPageComponent),
  //   data: {
  //     breadcrumb: {
  //       label: 'STUDENT_JOIN_US_REQUEST',
  //       icon: 'school',
  //     },
  //     permissions: [Permissions.User_Management_Student_Join_US],
  //   },
  // },
  // {
  //   path: RoutesConstants.UPGRADE_STUDENTS_REQUESTS_PAGE_URL,
  //   loadComponent: () =>
  //     import('./students-upgrade-requests/pages/students-upgrade-requests/students-upgrade-requests.component').then(
  //       (x) => x.StudentsUpgradeRequestsPageComponent
  //     ),
  //   data: {
  //     /* breadcrumb: {
  //       label: 'UPGRADE_STUDENTS_REQUESTS',
  //       icon: 'request_quote',
  //     }, */
  //     permissions: [
  //       Permissions.User_Management_Upgrade_Students_Request,
  //       Permissions.User_Management_Upgrade_DependentManager_Requests,
  //     ],
  //   },
  // },
  {
    path: RoutesConstants.TEACHERS_PAGE_URL,
    loadComponent: () =>
      import('./teachers/pages/teachers-page/teachers-page.component').then((x) => x.TeachersPageComponent),
    data: {
      /* breadcrumb: {
        label: 'TEACHERS',
        icon: 'edit',
      }, */
      permissions: [
        Permissions.User_Management_Reset_Rating_teacher,
        Permissions.User_Management_Reset_Balance,
        Permissions.User_Management_Disable_Teacher_Account,
        Permissions.User_Management_Teacher_Category,
        Permissions.User_Management_Disable_Student_Reservation,
      ],
    },
  },

  {
    path: RoutesConstants.CONSULTANT_BALANCE_PAGE_URL,
    loadComponent: () =>
      import('./consultant-balance/pages/consultant-balance-page/consultant-balance-page.component').then(
        (x) => x.ConsultantBalancePageComponent
      ),
    // data: {
    //   permissions: [Permissions.User_Management_Consultant_Balance],
    // },
  },
  // {
  //   path: RoutesConstants.BENEFICIARIES_PAGE_URL,
  //   loadComponent: () =>
  //     import('./beneficiaries/pages/beneficiaries-page/beneficiaries-page.component').then(
  //       (x) => x.BeneficiariesPageComponent
  //     ),
  //   data: {
  //     breadcrumb: {
  //       label: 'BENEFICIARIES',
  //       icon: 'supervised_user_circle',
  //     },
  //     permissions: [Permissions.User_Management_Beneficiaries]
  //   },
  // },
  /* {
    path: RoutesConstants.TEACHER_JOIN_REQUEST_PAGE_URL,
    loadComponent: () =>
      import('./teachers-join-request/pages/teachers-join-request-page/teachers-join-request-page.component').then(
        (x) => x.TeachersJoinRequestPageComponent
      ),
    data: {
      breadcrumb: {
        label: 'TEACHER_JOIN_US_REQUEST',
        icon: 'person_add',
      },
      permissions: [Permissions.User_Management_Teacher_Join_US]
    },
  }, */
  /*  {
    path: RoutesConstants.RECEIVABLES_PAGE_URL,
    loadComponent: () =>
      import('./receivables/pages/receivables-page/receivables-page.component').then(
        (x) => x.ReceivablesPageComponent
      ),
    data: {
      breadcrumb: {
        label: 'RECEIVABLES',
        icon: 'attach_money',
      },
      permissions: [Permissions.User_Management_Teacher_Receivables]
    },
  }, */
];

for (const route of MANAGE_USERS_ACCOUNTS_ROUTES) {
  route.canActivate = [PermissionGuard];
}
